import {
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Avatar,
  Badge,
  Box,
  CircularProgress,
  Modal,
  Skeleton,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import {
  useFirstName,
  useInvoffUserid,
  useLastName,
} from "../../../hooks/useLocalStorage";
import { getColorProfile } from "../../../utils/getColorProfile";
import UserSearch from "./UserSearch";
import moment from "moment";
import ShortcutIcon from "@mui/icons-material/Shortcut";
import ContactChatWindow from "./ContactChatWindow";
import {
  getChatConversation,
  getChatRequest,
  sendChatRequestAction,
} from "../../../actions/chat";
import { userTypes } from "../../../utils/ChatUserTypes";
import NoDataLabel from "../../../components/NoDataLabel";
import useLocalization from "../../../hooks/useLocalization";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ChatWindowContent = ({
  chatRequestedAlert,
  online_users,
  isAccordionExpanded,
  openMessageRequest,
  chatRequestData,
  setChatRequestData,
}) => {
  const dispatch = useDispatch();
  const themebody = useTheme()?.palette?.primary;
  const [tabValue] = useState(0);
  const [openChatWindowChild, setOpenChatWindowChild] = useState(false);
  const [selectedContact, setSelectedContact] = useState();
  const { chatConversation } = useSelector((state) => state.chat);

  useEffect(() => {
    if (isAccordionExpanded) {
      dispatch(
        getChatConversation({
          pageNo: 1,
          userType: userTypes?.[tabValue],
        })
      );
      const page = 1;
      dispatch(getChatRequest(page));
    }
  }, [tabValue, isAccordionExpanded, chatRequestedAlert]);

  const handleCloseChatWindowChild = () => {
    setSelectedContact();
    setOpenChatWindowChild(false);
  };

  return (
    <Box sx={{ position: "relative" }}>
      {/* {openMessageRequest ? (
        <Box sx={{ height: "555px" }}>
          <ChatRequests
            setChatRequestData={setChatRequestData}
            chatRequestData={chatRequestData}
            tabValue={tabValue}
          />
        </Box>
      ) : ( */}
      <Box sx={{ height: "calc(100vh - 265px)" }}>
        <UserSearch
          tabValue={tabValue}
          setSelectedContact={setSelectedContact}
          setOpenChatWindowChild={setOpenChatWindowChild}
        />
        <Recent
          isAccordionExpanded={isAccordionExpanded}
          online_users={online_users}
          setChatRequestData={setChatRequestData}
          tabValue={tabValue}
          chatRequestData={chatRequestData}
          chatConversationData={chatConversation ?? []}
          setOpenChatWindowChild={setOpenChatWindowChild}
          setSelectedContact={setSelectedContact}
        />
        {/* <TabContainer
            online_users={online_users}
            tabValue={tabValue}
            setTabValue={setTabValue}
            chatRequestData={chatRequestData}
            setChatRequestData={setChatRequestData}
            // chatConversationData={[]}
            chatConversationData={chatConversation ?? []}
            setOpenChatWindowChild={setOpenChatWindowChild}
            setSelectedContact={setSelectedContact}
          /> */}
        <Modal
          open={openChatWindowChild}
          onClose={() => {
            dispatch({
              type: "CLEAR_CHAT_MESSAGES",
            });
            handleCloseChatWindowChild();
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              bottom: 3,
              right: {
                xs: 4,
                sm: 40,
                md: 340,
              },
              bgcolor: themebody?.whitecolor,
              borderRadius: 3,
              border: "none",
              width: {
                xs: "360px",
                sm: "400px",
                md: "450px",
              },
            }}
          >
            <ContactChatWindow
              tabValue={tabValue}
              setChatRequestData={setChatRequestData}
              setSelectedContact={setSelectedContact}
              selectedContact={selectedContact}
              handleCloseChatWindowChild={() => {
                dispatch({
                  type: "CLEAR_CHAT_MESSAGES",
                });
                handleCloseChatWindowChild();
              }}
              contact={selectedContact}
            />
          </Box>
        </Modal>
      </Box>
      {/* )} */}
    </Box>
  );
};

export default ChatWindowContent;

const CommonChatInbox = ({
  chatConversationData,
  setOpenChatWindowChild,
  setSelectedContact,
  isWinBig,
  tabValue,
  online_users,
}) => {
  const themebody = useTheme()?.palette?.primary;
  // const { t } = useLocalization("chat");
  const firstName = useFirstName();
  const lastName = useLastName();
  const currentUser = useInvoffUserid();
  const randomProfileBg = getColorProfile({ firstName, lastName });

  const [updatedConversations, setUpdatedConversations] = useState([]);

  const { chatConversationLoading } = useSelector((state) => state.chat);

  const handleUserClick = (user) => {
    setSelectedContact(user);
    setOpenChatWindowChild(true);
  };

  const renderLoader = (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        px: 1,
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginTop: "6px",
      }}
    >
      <Skeleton height="40px" animation="wave" />
      <Skeleton height="40px" animation="wave" />
      <Skeleton height="40px" animation="wave" />
      <Skeleton height="40px" animation="wave" />
      <Skeleton height="40px" animation="wave" />
      <Skeleton height="40px" animation="wave" />
    </Box>
  );

  useEffect(() => {
    const updatedConversation = chatConversationData?.map((conversation) => {
      const updatedSender = { ...conversation?.sender };
      const statusObject = online_users?.find(
        (status) => status?.user === updatedSender?.invoffuserid
      );
      if (statusObject) {
        updatedSender.status = statusObject?.status;
      }
      return { ...conversation, sender: updatedSender };
    });
    setUpdatedConversations(updatedConversation);
  }, [JSON.stringify(online_users), JSON.stringify(chatConversationData)]);

  return (
    <Box
      sx={{
        width: "100%",
        overflow: "auto",
        height: "500px",
        marginTop: "10px",
      }}
    >
      {!chatConversationLoading && updatedConversations?.length > 0 && (
        <Typography
          sx={{
            color: themebody?.textcolor,
            fontSize: "14px",
            marginTop: "0px",
            marginBottom: "10px",
          }}
        >
          {"Recent"} {"Messages"}
          {/* {userTypes[tabValue] === ""
            ? "Recent"
            : userTypes[tabValue] === "crm"
            ? "Internal"
            : "External"}{" "} */}
        </Typography>
      )}
      {chatConversationLoading ? (
        renderLoader
      ) : updatedConversations && updatedConversations?.length !== 0 ? (
        updatedConversations?.map((request) => {
          const {
            last_message,
            sender: {
              first_name = "",
              last_name = "",
              profile_pic = "",
              status,
            } = {},
          } = request ?? {};
          const fullName = `${first_name} ${last_name}`;
          return (
            <Box
              onClick={() => handleUserClick(request)}
              sx={{
                mt: 0.5,
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: themebody?.lightGrey,
                },
              }}
              key={request?.id}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      width: "100%",
                    }}
                  >
                    <Box flexShrink={0}>
                      <Badge
                        sx={{
                          "& .MuiBadge-badge": {
                            backgroundColor:
                              status && status === "ONLINE"
                                ? themebody?.sucesscolor
                                : status === "OFFLINE"
                                ? themebody?.warningdarkcolor
                                : themebody?.warningdarkcolor,
                            color:
                              status && status === "ONLINE"
                                ? themebody?.sucesscolor
                                : status === "OFFLINE"
                                ? themebody?.warningdarkcolor
                                : themebody?.warningdarkcolor,
                            boxShadow: `0 0 0 2px`,
                            "&::after": {
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              borderRadius: "50%",
                              animation: "ripple 1.2s infinite ease-in-out",
                              border: "1px solid currentColor",
                              content: '""',
                            },
                          },
                          "@keyframes ripple": {
                            "0%": {
                              transform: "scale(.8)",
                              opacity: 1,
                            },
                            "100%": {
                              transform: "scale(2.4)",
                              opacity: 0,
                            },
                          },
                        }}
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        variant="dot"
                      >
                        <Avatar
                          variant="contained"
                          alt={first_name}
                          src={profile_pic !== "undefined" && `${profile_pic}`}
                          sx={{
                            fontSize: "14px",
                            width: "32px",
                            height: "32px",
                            background: randomProfileBg,
                          }}
                        >
                          {first_name?.[0]?.toUpperCase() +
                            last_name?.[0]?.toUpperCase()}
                        </Avatar>
                      </Badge>
                      {/* <RenderProfileImage
                        size="34px"
                        imageUrl={profile_pic}
                        fontsize=""
                        firstCharacter={first_name[0] + last_name[0]}
                      /> */}
                    </Box>
                    <Box sx={{ width: "100%" }}>
                      <Typography
                        sx={{
                          paddingTop: "2px",
                          paddingLeft: "2px",
                          fontSize: "0.8rem",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {fullName}
                      </Typography>
                      {/* </Badge> */}
                      <Typography
                        sx={{
                          width: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          fontSize: "0.8rem",
                          color:
                            last_message?.sender !== currentUser &&
                            last_message?.status !== "SEEN"
                              ? ""
                              : themebody?.textcolor,
                          mt: 0.5,
                          fontWeight:
                            last_message?.sender !== currentUser &&
                            last_message?.status !== "SEEN"
                              ? "bold"
                              : "",
                        }}
                      >
                        {last_message?.is_active ? (
                          last_message?.was_forwarded ? (
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                              }}
                            >
                              <ShortcutIcon fontSize="small" />
                              {last_message?.text_content}
                            </span>
                          ) : (
                            last_message?.text_content
                          )
                        ) : (
                          <span
                            style={{
                              fontSize: "10px",
                              fontStyle: "italic",
                            }}
                          >
                            {"Message"} {"Deleted"}
                          </span>
                        )}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.8rem",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {moment(last_message?.created_at).format("DD MMM")}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 10,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {request?.sender?.user_type}
                  </Typography>
                </Box>
              </div>
              <Box
                sx={{
                  height: "1.5px",
                  width: "96%",
                  mt: "6px",
                  background: themebody?.grey,
                }}
              ></Box>
            </Box>
          );
        })
      ) : (
        <Box mt={2}>
          <Typography>
            <NoDataLabel textAlign={"center"} />
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export const Recent = ({
  handleChildChatOpenWindow,
  setOpenChatWindowChild,
  setSelectedContact,
  chatConversationData,
  isWinBig,
  chatRequestData,
  setChatRequestData,
  tabValue,
  online_users,
  isAccordionExpanded,
}) => {
  return (
    <Box sx={{ paddingX: "10px" }}>
      <ChatRequests
        isAccordionExpanded={isAccordionExpanded}
        setChatRequestData={setChatRequestData}
        chatRequestData={chatRequestData}
        tabValue={tabValue}
      />
      <CommonChatInbox
        online_users={online_users}
        tabValue={tabValue}
        isWinBig={isWinBig}
        setSelectedContact={setSelectedContact}
        chatConversationData={chatConversationData}
        chatRequest={chatRequestData}
        handleChildChatOpenWindow={handleChildChatOpenWindow}
        setOpenChatWindowChild={setOpenChatWindowChild}
      />
    </Box>
  );
};

// export const Internal = ({
//   handleChildChatOpenWindow,
//   setOpenChatWindowChild,
//   setSelectedContact,
//   chatConversationData,
//   isWinBig,
//   chatRequestData,
//   tabValue,
//   online_users,
// }) => {
//   return (
//     <Box>
//       <CommonChatInbox
//         online_users={online_users}
//         tabValue={tabValue}
//         isWinBig={isWinBig}
//         setSelectedContact={setSelectedContact}
//         chatConversationData={chatConversationData}
//         chatRequest={chatRequestData}
//         handleChildChatOpenWindow={handleChildChatOpenWindow}
//         setOpenChatWindowChild={setOpenChatWindowChild}
//       />
//     </Box>
//   );
// };

// export const External = ({
//   handleChildChatOpenWindow,
//   setOpenChatWindowChild,
//   setSelectedContact,
//   chatConversationData,
//   isWinBig,
//   chatRequestData,
//   tabValue,
//   online_users,
// }) => {
//   return (
//     <Box>
//       <CommonChatInbox
//         online_users={online_users}
//         tabValue={tabValue}
//         isWinBig={isWinBig}
//         setSelectedContact={setSelectedContact}
//         chatConversationData={chatConversationData}
//         chatRequest={chatRequestData}
//         handleChildChatOpenWindow={handleChildChatOpenWindow}
//         setOpenChatWindowChild={setOpenChatWindowChild}
//       />
//     </Box>
//   );
// };

export const ChatRequests = ({
  chatRequestData,
  tabValue,
  setChatRequestData,
  isAccordionExpanded,
}) => {
  const page = 1;
  // const { t } = useLocalization("chat");
  const dispatch = useDispatch();
  const [activeActionId, setActiveActionId] = useState();
  const [actionType, setActionType] = useState("");
  const [isRequestAccordingOpen, setIsRequestAccordingOpen] = useState(false);

  const { chatRequest: chatRequestApiData } = useSelector(
    (state) => state?.chat
  );
  const currentUser = useInvoffUserid();
  const firstName = useFirstName();
  const lastName = useLastName();
  const randomProfileBg = getColorProfile({ firstName, lastName });

  useEffect(() => {
    if (isAccordionExpanded) {
      dispatch(getChatRequest(page));
    }
  }, [isAccordionExpanded]);

  useEffect(() => {
    setChatRequestData(chatRequestApiData?.data ?? []);
  }, [chatRequestApiData?.data]);

  const userType = userTypes?.[tabValue];

  const pendingChatReceiveRequest = chatRequestData?.filter(
    (item) => item.status == "PENDING" && item?.receiver === currentUser
  );

  const pendingChatSendRequest = chatRequestData?.filter(
    (item) => item.status == "PENDING" && item?.receiver !== currentUser
  );

  const { chatActionLoading, chatConversationLoading } = useSelector(
    (state) => state.chat
  );

  const handleAcceptRequest = (id) => {
    setActionType("accept");
    const payload = { action: "accept" };
    !chatActionLoading &&
      dispatch(
        sendChatRequestAction({
          id,
          payload,
          userType,
        })
      );
  };

  const handleDeclineRequest = (id) => {
    setActionType("decline");
    const payload = { action: "reject" };
    !chatActionLoading &&
      dispatch(
        sendChatRequestAction({
          id,
          payload,
          userType,
        })
      );
  };

  const handleCancelRequest = (id) => {
    setActionType("cancel");
    const payload = { action: "cancel" };
    !chatActionLoading &&
      dispatch(
        sendChatRequestAction({
          id,
          payload,
          userType,
        })
      );
  };

  useEffect(() => {
    if (chatRequestData && chatRequestData?.length === 0) {
      setIsRequestAccordingOpen(false);
    }
  }, [chatRequestData]);

  const themebody = useTheme()?.palette?.primary;

  return (
    <div style={{ marginTop: "10px" }}>
      <Accordion
        expanded={isRequestAccordingOpen}
        onChange={(e, expanded) => {
          setIsRequestAccordingOpen(expanded);
        }}
        disableGutters
        elevation={0}
        sx={{
          "&:before": {
            display: "none",
          },
        }}
      >
        <AccordionSummary
          sx={{
            minHeight: 0,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
            padding: "0px !important",
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography sx={{ color: themebody?.textcolor, fontSize: "14px" }}>
            Manage Request{" "}
            {pendingChatReceiveRequest?.length > 0 &&
              `(${pendingChatReceiveRequest?.length})`}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0 }}>
          <Box marginTop={1}>
            {pendingChatSendRequest?.length > 0 && (
              <Typography
                sx={{ color: themebody?.textcolor, fontSize: "14px" }}
              >
                Sent Requests
              </Typography>
            )}
            {
              pendingChatSendRequest && pendingChatSendRequest?.length !== 0
                ? pendingChatSendRequest?.map((request) => {
                    const {
                      request_message,
                      id,
                      sender: {
                        first_name = "",
                        last_name = "",
                        profile_pic = "",
                      } = {},
                    } = request ?? {};
                    const fullName = `${first_name} ${last_name}`;
                    return (
                      <Box key={request?.id} mt={1}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "start",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              width: "100%",
                            }}
                          >
                            <Box flexShrink={0}>
                              <Avatar
                                variant="contained"
                                alt={first_name}
                                src={
                                  profile_pic !== "undefined" &&
                                  `${profile_pic}`
                                }
                                sx={{
                                  width: "34px",
                                  height: "34px",
                                  background: randomProfileBg,
                                }}
                              >
                                {first_name?.[0]?.toUpperCase() +
                                  last_name?.[0]?.toUpperCase()}
                              </Avatar>
                            </Box>
                            <Box sx={{ width: "100%" }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "0.9rem",
                                    overflowWrap: "anywhere",
                                  }}
                                >
                                  {fullName}
                                </Typography>
                              </Box>
                              <Typography
                                sx={{
                                  width: "150px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  fontSize: "0.8rem",
                                  color: themebody?.textcolor,
                                }}
                              >
                                {request_message}
                              </Typography>
                            </Box>
                          </Box>
                          {currentUser === request?.receiver ? (
                            <Box sx={{ display: "flex", gap: 2 }}>
                              <Tooltip title={`Accept`}>
                                <Box
                                  sx={{
                                    height: "28px",
                                    width: "28px",
                                    border: `1px solid ${themebody?.sucesscolor}`,
                                    borderRadius: 999,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderStyle: "dotted",
                                    cursor: "pointer",
                                  }}
                                >
                                  <Box
                                    onClick={() => {
                                      handleAcceptRequest(id);
                                      setActiveActionId(id);
                                    }}
                                    sx={{
                                      display: "flex",
                                      gap: "3px",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {chatActionLoading &&
                                    actionType === "accept" &&
                                    activeActionId === id ? (
                                      <CircularProgress
                                        sx={{
                                          color: themebody?.sucesscolor,
                                        }}
                                        size={27}
                                      />
                                    ) : (
                                      <DoneOutlinedIcon
                                        sx={{ color: themebody?.sucesscolor }}
                                      />
                                    )}
                                  </Box>
                                </Box>
                              </Tooltip>
                              <Tooltip title={`Decline`}>
                                <Box
                                  onClick={() => {
                                    handleDeclineRequest(id);
                                    setActiveActionId(id);
                                  }}
                                  sx={{
                                    height: "28px",
                                    width: "28px",
                                    border: `1px solid ${themebody?.errorcolor}`,
                                    borderRadius: 999,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderStyle: "dotted",
                                    cursor: "pointer",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: "0.5",
                                      alignItems: "center",
                                    }}
                                  >
                                    {chatActionLoading &&
                                    actionType === "decline" &&
                                    activeActionId === id ? (
                                      <CircularProgress
                                        sx={{ color: themebody?.errorcolor }}
                                        size={27}
                                      />
                                    ) : (
                                      <CloseOutlinedIcon
                                        sx={{ color: themebody?.errorcolor }}
                                      />
                                    )}
                                  </Box>
                                </Box>
                              </Tooltip>
                            </Box>
                          ) : (
                            <Tooltip title={`Cancel`}>
                              <Box
                                onClick={() => {
                                  handleCancelRequest(id);
                                  setActiveActionId(id);
                                }}
                                sx={{
                                  height: "28px",
                                  width: "28px",
                                  border: `1px solid ${themebody?.errorcolor}`,
                                  borderRadius: 999,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderStyle: "dotted",
                                  cursor: "pointer",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: "0.5",
                                    alignItems: "center",
                                  }}
                                >
                                  {chatActionLoading &&
                                  actionType === "cancel" &&
                                  activeActionId === id ? (
                                    <CircularProgress
                                      sx={{ color: themebody?.errorcolor }}
                                      size={27}
                                    />
                                  ) : (
                                    <CloseOutlinedIcon
                                      sx={{ color: themebody?.errorcolor }}
                                    />
                                  )}
                                </Box>
                              </Box>
                            </Tooltip>
                          )}
                        </Box>
                        <Box
                          sx={{
                            height: "1.5px",
                            width: "96%",
                            mt: "6px",
                            background: themebody?.graycolor,
                          }}
                        ></Box>
                      </Box>
                    );
                  })
                : null
              // <Box mt={2}>
              //   <Typography>
              //     <NoDataLabel textAlign={"center"} />
              //   </Typography>
              // </Box>
            }
          </Box>
          <Box marginTop={1}>
            {pendingChatReceiveRequest?.length > 0 && (
              <Typography
                sx={{ color: themebody?.textcolor, fontSize: "14px" }}
              >
                {"Message Requests"}
              </Typography>
            )}
            {
              pendingChatReceiveRequest &&
              pendingChatReceiveRequest?.length !== 0
                ? pendingChatReceiveRequest?.map((request) => {
                    const {
                      request_message,
                      id,
                      sender: {
                        first_name = "",
                        last_name = "",
                        profile_pic = "",
                      } = {},
                    } = request ?? {};
                    const fullName = `${first_name} ${last_name}`;
                    return (
                      <Box key={request?.id} mt={1}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "start",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              width: "100%",
                            }}
                          >
                            <Box flexShrink={0}>
                              <Avatar
                                variant="contained"
                                alt={first_name}
                                src={
                                  profile_pic !== "undefined" &&
                                  `${profile_pic}`
                                }
                                sx={{
                                  width: "34px",
                                  height: "34px",
                                  background: randomProfileBg,
                                }}
                              >
                                {first_name?.[0]?.toUpperCase() +
                                  last_name?.[0]?.toUpperCase()}
                              </Avatar>
                            </Box>
                            <Box sx={{ width: "100%" }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "0.9rem",
                                  }}
                                >
                                  {fullName}
                                </Typography>
                              </Box>
                              <Typography
                                sx={{
                                  width: "150px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  fontSize: "0.8rem",
                                  color: themebody?.textcolor,
                                }}
                              >
                                {request_message}
                              </Typography>
                            </Box>
                          </Box>
                          {currentUser === request?.receiver ? (
                            <Box sx={{ display: "flex", gap: 2 }}>
                              <Box
                                sx={{
                                  height: "28px",
                                  width: "28px",
                                  border: `1px solid ${themebody?.sucesscolor}`,
                                  borderRadius: 999,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderStyle: "dotted",
                                }}
                              >
                                <Tooltip title={`Accept`}>
                                  <Box
                                    onClick={() => {
                                      handleAcceptRequest(id);
                                      setActiveActionId(id);
                                    }}
                                    sx={{
                                      display: "flex",
                                      gap: "3px",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {chatActionLoading &&
                                    actionType === "accept" &&
                                    activeActionId === id ? (
                                      <CircularProgress
                                        sx={{
                                          color: themebody?.sucesscolor,
                                        }}
                                        size={27}
                                      />
                                    ) : (
                                      <DoneOutlinedIcon
                                        sx={{ color: themebody?.sucesscolor }}
                                      />
                                    )}
                                  </Box>
                                </Tooltip>
                              </Box>
                              <Tooltip title={`Decline`}>
                                <Box
                                  onClick={() => {
                                    handleDeclineRequest(id);
                                    setActiveActionId(id);
                                  }}
                                  sx={{
                                    height: "28px",
                                    width: "28px",
                                    border: `1px solid ${themebody?.errorcolor}`,
                                    borderRadius: 999,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderStyle: "dotted",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: "0.5",
                                      alignItems: "center",
                                    }}
                                  >
                                    {chatActionLoading &&
                                    actionType === "decline" &&
                                    activeActionId === id ? (
                                      <CircularProgress
                                        sx={{ color: themebody?.errorcolor }}
                                        size={27}
                                      />
                                    ) : (
                                      <CloseOutlinedIcon
                                        sx={{ color: themebody?.errorcolor }}
                                      />
                                    )}
                                  </Box>
                                </Box>
                              </Tooltip>
                            </Box>
                          ) : (
                            <Tooltip title={`Cancel`}>
                              <Box
                                onClick={() => {
                                  handleCancelRequest(id);
                                  setActiveActionId(id);
                                }}
                                sx={{
                                  height: "28px",
                                  width: "28px",
                                  border: `1px solid ${themebody?.errorcolor}`,
                                  borderRadius: 999,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderStyle: "dotted",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: "0.5",
                                    alignItems: "center",
                                  }}
                                >
                                  {chatActionLoading &&
                                  actionType === "cancel" &&
                                  activeActionId === id ? (
                                    <CircularProgress
                                      sx={{ color: themebody?.errorcolor }}
                                      size={27}
                                    />
                                  ) : (
                                    <CloseOutlinedIcon
                                      sx={{ color: themebody?.errorcolor }}
                                    />
                                  )}
                                </Box>
                              </Box>
                            </Tooltip>
                          )}
                        </Box>
                        <Box
                          sx={{
                            height: "1.5px",
                            width: "96%",
                            mt: "6px",
                            background: themebody?.graycolor,
                          }}
                        ></Box>
                      </Box>
                    );
                  })
                : null
              // <Box mt={2}>
              //   <Typography textAlign="center">
              //     <NoDataLabel textAlign={"center"} />
              //   </Typography>
              // </Box>
            }
          </Box>
          {chatRequestData?.length === 0 && (
            <Box>
              <NoDataLabel
                fontSize={themebody?.setPageFontSize?.headingseven}
              />
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
